import keyMirror from "keymirror";

export default keyMirror({
  SUBMIT_INTERESTED_REQUEST: null,
  SUBMIT_INTERESTED_SUCCESS: null,
  SUBMIT_INTERESTED_FAILURE: null,
});
